import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "innerHTML"]

import { PropType } from 'vue'
import { iconPaths, IconName } from '@/component/ui/icons'


export default /*@__PURE__*/_defineComponent({
  __name: 'AtlasIcon',
  props: {
  name: { type: String as PropType<IconName>, required: true },
  size: { type: Number, default: 16 },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "icon",
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.75",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true",
    innerHTML: _unref(iconPaths)[__props.name]
  }, null, 8, _hoisted_1))
}
}

})